import { useState, useEffect } from 'react'
import Match from "../components/Match"
import { db } from '../firebase'
import { useAuth } from "../contexts/AuthContext"
import '../css/Match.css'
import ConnectionToast from "../components/ConnectionToast"
import '../css/Base.css'
import StarBorder from '@material-ui/icons/StarBorder';

function Favorites() {

    const [isLoading, setIsLoading] = useState(true);
    const [loadedData, setLoadedData] = useState([]);
    const { currentUser } = useAuth()

    useEffect(() => {
        setIsLoading(true);

        var arrayData = []
        var docRef1 = db.collection("Players").doc(`${currentUser.uid}`).collection("Favorites")

        var counter = 0;
        var processedFavorites = 0;

        docRef1.get().then((querySnapshot) => {
            counter = querySnapshot.size;

            querySnapshot.forEach((doc) => {
                arrayData.push(doc.data())
                processedFavorites++

                if (processedFavorites === counter) {
                    setLoadedData(arrayData)
                    setIsLoading(false)
                }

            });
        });

        // OFFLINE ONLINE TOAST
        let connectionLostToast = document.getElementById('connectionLost')
        connectionLostToast.setAttribute('autohide', false)

        window.addEventListener('offline', function () {
            connectionLostToast.style.display = "block"
        });

        window.addEventListener('online', function () {
            connectionLostToast.style.display = "none"
        });

    }, [currentUser.uid])

    //if we are loading the data return loading .. 
    if (isLoading && loadedData.length === 0) {
        return (
            <>
                <div className="col-md-6 offset-md-2 pt-5">
                    <h1 className="text-light text-center pt-5 mb-4 font-link-header">NO. FAVORITES. YET.
                        <br /> CLICK. THAT. STAR <StarBorder /></h1>
                </div>
                <ConnectionToast />
            </>
        )
    }

    //if we are loading the data return loading .. 
    if (isLoading) {
        return (
            <>
                <div className="lds-circle" />
                <ConnectionToast />
            </>
        )
    }



    return (
        <div className='cntr'>
            <ConnectionToast />
            <div className="row g-0 justify-content-md-end rowwithmargin pt-5">
                <h1 className="col-md-10 mb-3 font-link-header2">
                    YOUR. FAVORITES. ({loadedData.length})
                </h1>
                {loadedData.map((data) => {
                    return (
                        <div key={data.id} className="col-md-9 col-sm-1 mb-4">
                            <Match
                                id={data.id}
                                teams={data.teams}
                                dateAndTime={data.dateAndTime}
                                date={data.date}
                                time={data.time}
                                league={data.league}
                                logoLocalTeam={data.logoLocalTeam}
                                logoVisitorTeam={data.logoVisitorTeam}
                                timestamp={data.timestamp}
                                predictionLocal={data.predictionLocal}
                                predictionVisitor={data.predictionVisitor}
                                predictionDraw={data.predictionDraw}
                                isFavorite={data.isFavorite}>
                            </Match>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Favorites